import type { BlockConfig } from '../../domain/entities/block-config.entity';
import type { RemoteConfigDatasource } from '../datasources/remote-config.datasource';

export class MaintenanceRepositoryImpl {
  private readonly remoteConfig: RemoteConfigDatasource;

  constructor(remoteConfig: RemoteConfigDatasource) {
    this.remoteConfig = remoteConfig;
  }

  async getBlockConfig(): Promise<BlockConfig> {
    return this.remoteConfig.getBlockConfig();
  }
}
